// noinspection ExceptionCaughtLocallyJS

import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiRequestsFilters, getRequests } from '../../../services/requestEndPoints';
import {
  IRequestsPayloadState,
  RequestData,
  RequestsInterface,
} from 'interfaces/request.interface';
import apiFetch from 'services/apiFetch';

export const fetchArchived = createAsyncThunk(
  'archived/fetchArchived',
  async (filters: ApiRequestsFilters) => {
    try {
      const endpoint = getRequests(filters);
      const response = await apiFetch<RequestsInterface>(endpoint).then((res) => res.data || null);

      if (response) {
        const requestsData: RequestData[] = response.data.map((item) => {
          return {
            id: item.id,
            deleted: item.deleted,
            archived: item.archived,
            requestNumber: item.requestNumber,
            palmettoResourceRequest: item.palmettoResourceRequest,
            onSceneContactPerson: item.onSceneContactPerson,
            onSceneContactPhone: item.onSceneContactPhone,
            missionType: item.missionType,
            date: item.date,
            departmentName: item.departmentName,
            contactPerson: item.contactPerson,
            contactPhone: item.contactPhone,
            stagingLocation: item.stagingLocation,
            destination: item.destination,
            notes: item.notes,
            ambulance: item.ambulance,
            personnel: item.personnel,
            counties: item.counties,
            serviceType: item.serviceType,
            agencies: item.agencies,
            emailBody: item.emailBody,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
            incident: item.incident,
            responses: item.responses,
          };
        });

        const page = response.page;
        const lastPage = response.last_page;
        const pagesTotal = response.total;

        const payload: IRequestsPayloadState = {
          requests: requestsData,
          page: page,
          lastPage: lastPage,
          pagesTotal: pagesTotal,
        };

        return payload;
      } else {
        throw 'No data found';
      }
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('fetchArchive catch:', message);
      throw Error(message);
    }
  },
);
